import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";

/** Where a detail page was opened from; carried as `?via=` so a fresh tab still knows where "back" is. */
export type DetailOrigin = "requests" | "operations";

const ORIGIN: Record<DetailOrigin, { to: string; label: string }> = {
  requests: { to: "/requests", label: "Back to requests" },
  operations: { to: "/operations", label: "Back to Operations" },
};

export function parseDetailOrigin(value: string | null): DetailOrigin {
  return value === "operations" ? "operations" : "requests";
}

/**
 * Back link for the Request Detail screen. When the router pushed this page (the user navigated here
 * inside the app) it goes one step back, keeping the list's filters. When the page is the first entry
 * in its tab (opened in a new tab from the Operations drawer, or pasted) there is nothing behind it,
 * so the link is a plain route to the originating screen.
 */
export function BackLink() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const origin = ORIGIN[parseDetailOrigin(searchParams.get("via"))];
  const hasHistory = location.key !== "default";
  return (
    <Link
      className="back-link"
      to={origin.to}
      onClick={(e) => {
        if (!hasHistory) return;
        e.preventDefault();
        navigate(-1);
      }}
    >
      <span className="material-symbols-rounded" style={{ fontSize: 16 }}>arrow_back</span>
      {origin.label}
    </Link>
  );
}
